import { render, staticRenderFns } from "./splitOrder.vue?vue&type=template&id=0198af9c&scoped=true"
import script from "./splitOrder.vue?vue&type=script&lang=js"
export * from "./splitOrder.vue?vue&type=script&lang=js"
import style0 from "./splitOrder.vue?vue&type=style&index=0&id=0198af9c&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0198af9c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/Prod-五域创客/jh-5eck-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0198af9c')) {
      api.createRecord('0198af9c', component.options)
    } else {
      api.reload('0198af9c', component.options)
    }
    module.hot.accept("./splitOrder.vue?vue&type=template&id=0198af9c&scoped=true", function () {
      api.rerender('0198af9c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/orderBox/splitOrder.vue"
export default component.exports